import { createFileRoute, Outlet } from "@tanstack/react-router"
import Header from "@/components/Header"
import { PublicFooter } from "@/components/PublicFooter"

export const Route = createFileRoute(`/_public`)({
  // Marketing pages are server-rendered for fast FCP/LCP + crawler-ready HTML.
  // The root `rootSsr` gate permits it for these pathnames; each leaf also sets
  // `ssr: true` (a leaf would otherwise fall back to defaultSsr:false).
  ssr: true,
  component: PublicLayout,
})

function PublicLayout() {
  return (
    <div className="flex flex-col min-h-dvh">
      <Header />
      <main className="flex-1 pt-[3.25rem]">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  )
}
